import {ProDirectory_GetOfferingsGql} from '../../../../__generated__/types'
import {ChangeDetectionStrategy, Component, input, Input, OnDestroy, OnInit} from '@angular/core'
import {Subject} from 'rxjs'
import {takeUntil} from 'rxjs/operators'
import {TranslocoModule} from '@ngneat/transloco'
import {FilterModule} from '../../../craft/filter/filter.module'
import {CommonModule} from '@angular/common'
import {ProDirectoryModule} from '../pro-directory/pro-directory.module'
import {ButtonModule} from '../../../craft/button/button.module'
import {SortingModule} from '../../../craft/sorting/sorting.module'
import {MessageModule} from '../../../craft/message/message.module'
import {CardsModule} from '../../../craft/cards/cards.module'
import {Region} from '../../../core/content/types/craftsmen-region-types'

@Component({
  selector: 'bgo-pro-directory-by-offering-section',
  templateUrl: './pro-directory-by-offering-section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FilterModule,
    SortingModule,
    ProDirectoryModule,
    ButtonModule,
    MessageModule,
    CardsModule,
    TranslocoModule,
  ],
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class ProDirectoryByOfferingSectionComponent implements OnInit, OnDestroy {
  @Input() offeringIds: string[] = []
  @Input() title!: string

  region = input<Region>()

  protected offeringNames: string[] = []
  protected total = 0

  private unsubscribe$ = new Subject<void>()

  constructor(private getOfferingsGql: ProDirectory_GetOfferingsGql) {}

  ngOnInit(): void {
    this.getOfferingsGql
      .fetch({offeringIds: this.offeringIds})
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(({data: {offeringByIds}}) => {
        this.offeringNames = offeringByIds.map(o => o.label)
      })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }
}
